import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import { store } from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import AlertComponent from './components/Shared/Alert.vue'

import VueSocketIO from 'vue-socket.io'
import api from './api'

Vue.use(new VueSocketIO({
  debug: false,
  connection: api.connection(),
  vuex: {
    store,
    actionPrefix: 'socket_',
    mutationPrefix: 'socket_'
  }
}))

Vue.use(Vuetify)
Vue.use(VueResource)

Vue.config.productionTip = false

Vue.component('app-alert', AlertComponent)

export default new Vue({
  router,
  store,
  created () {
    // TODO
  },
  render: h => h(App)
}).$mount('#app')
